import { render, staticRenderFns } from "./RipaTemplate.vue?vue&type=template&id=1306c18c"
import script from "./RipaTemplate.vue?vue&type=script&lang=js"
export * from "./RipaTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports